import React from 'react';
import { Skeleton } from '@mui/material';
import { teal } from '@mui/material/colors';
import { BarChart } from '@mui/x-charts';
import { LenderTotalCostRowViewModel } from '@trnsact/trnsact-shared-types';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { LOOK_TO_BOOK_CHART_HEIGHT } from '../../../../constants';
import { formatCompactCurrency, mapTotalCostByLenderDataset } from '../../../../lib';
import { ReportCardProps } from '../../../../types';

const LABEL_CHAR_WIDTH = 7;
const LABEL_PADDING = 16;

export const TotalCostComparisonChart = ({ resource }: ReportCardProps<LenderTotalCostRowViewModel[]>) => {
  const dataset = mapTotalCostByLenderDataset(resource.data ?? []);

  const maxLenderNameLength = dataset.reduce((max, row) => Math.max(max, row.lender.length), 0);
  const leftMargin = maxLenderNameLength * LABEL_CHAR_WIDTH + LABEL_PADDING;

  return (
    <CardContainer title="Total cost comparison" subTitle="Doc fee comparison by lender">
      {resource.loading ? (
        <Skeleton variant="rounded" height={LOOK_TO_BOOK_CHART_HEIGHT} />
      ) : (
        <BarChart
          height={LOOK_TO_BOOK_CHART_HEIGHT}
          layout="horizontal"
          dataset={dataset}
          margin={{ left: leftMargin }}
          barLabel={item => {
            const row = dataset[item.dataIndex];
            return row ? formatCompactCurrency(row.docFee) : '';
          }}
          yAxis={[{ scaleType: 'band', dataKey: 'lender' }]}
          xAxis={[{ valueFormatter: value => formatCompactCurrency(value as number), tickNumber: 4 }]}
          series={[
            {
              dataKey: 'docFee',
              label: 'Doc fee',
              color: teal[300],
              valueFormatter: value => formatCompactCurrency(value as number),
            },
          ]}
          slotProps={{
            legend: { hidden: true },
            noDataOverlay: { message: 'No data available for the selected filters' },
          }}
        />
      )}
    </CardContainer>
  );
};
